import React from 'react'
import { getPaginationButtons } from '../utils/utils'
import './Pagination.scss'

// Numbered pagination: Previous / 1 … 4 5 6 … 12 / Next.
//
// Props-driven so it isn't tied to any one store — ListingsPagination reads
// useListingsStore directly and can't be reused. The button range comes from the
// same getPaginationButtons helper the Listings controls use; that helper derives
// the current and last page from an offset, so passing a page size of 1 lets page
// numbers go straight through.
export const Pagination = ({ page, pageCount, onPageChange, label = 'Pagination' }) => {
    if (!pageCount || pageCount < 2) return null

    const current = Math.min(Math.max(page, 1), pageCount)
    const buttons = getPaginationButtons(current - 1, 1, pageCount)

    const go = (next) => {
        if (next < 1 || next > pageCount || next === current) return
        onPageChange(next)
    }

    return (
        <nav className="td-pagination" aria-label={label}>
            <button
                type="button"
                className="page-btn page-step"
                disabled={current === 1}
                onClick={() => go(current - 1)}
            >
                Previous
            </button>

            {buttons.map((entry, i) =>
                entry === '...' ? (
                    <span key={`gap-${i}`} className="page-gap" aria-hidden="true">…</span>
                ) : (
                    <button
                        type="button"
                        key={entry}
                        className={`page-btn${entry === current ? ' active' : ''}`}
                        aria-current={entry === current ? 'page' : undefined}
                        onClick={() => go(entry)}
                    >
                        {entry}
                    </button>
                )
            )}

            <button
                type="button"
                className="page-btn page-step"
                disabled={current === pageCount}
                onClick={() => go(current + 1)}
            >
                Next
            </button>
        </nav>
    )
}
